"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.text = exports.input = exports.button = exports.container = void 0;

var _util = require("../../../util");

const container = ({
  cssProps,
  theme
}) => {
  const {
    disabled
  } = cssProps;
  const {
    toggler
  } = theme.toggleButton;
  return {
    display: 'flex',
    position: 'relative',
    width: toggler.width,
    height: toggler.height,
    padding: (0, _util.spacing)(theme, toggler.padding),
    background: (0, _util.color)(theme, toggler.bg),
    borderRadius: toggler.borderRadius,
    transition: 'all 0.2s ease',
    cursor: disabled ? 'not-allowed' : 'pointer',
    ':active': {
      background: (0, _util.color)(theme, disabled ? toggler.bg : toggler.activeBg)
    }
  };
};

exports.container = container;

const button = ({
  cssProps,
  theme
}) => {
  const {
    selectedTab,
    disabled,
    variant = 'primary'
  } = cssProps;
  const buttonTheme = variant === 'buySell' ? theme.toggleButton[selectedTab === 1 ? 'buy' : 'sell'] : theme.toggleButton[variant];
  return {
    position: 'absolute',
    transform: "translateX(".concat(selectedTab === 1 ? 0 : 'calc(100% - 8px)', ")"),
    width: buttonTheme.width,
    height: buttonTheme.height,
    boxShadow: (0, _util.boxShadow)(theme, buttonTheme.boxShadow),
    background: (0, _util.color)(theme, disabled ? buttonTheme.disabledBg : buttonTheme.bg),
    borderRadius: buttonTheme.borderRadius,
    transition: 'all 0.2s ease'
  };
};

exports.button = button;

const input = () => ({
  appearance: 'none',
  position: 'absolute',
  top: 0,
  left: 0,
  margin: 0,
  width: '100%',
  height: '100%',
  color: 'transparent',
  ':disabled': {
    cursor: 'not-allowed'
  }
});

exports.input = input;

const text = ({
  cssProps,
  theme
}) => {
  const {
    selectedTab,
    disabled,
    variant = 'primary',
    isSelected
  } = cssProps;
  const buttonTheme = variant === 'buySell' ? theme.toggleButton[selectedTab === 1 ? 'buy' : 'sell'] : theme.toggleButton[variant];
  const textTheme = buttonTheme[isSelected ? 'activeText' : 'inactiveText'];
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50%',
    height: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: (0, _util.color)(theme, disabled ? textTheme.colorDisabled : textTheme.color),
    pointerEvents: 'none',
    ':last-of-type': {
      left: '50%'
    }
  };
};

exports.text = text;
//# sourceMappingURL=ToggleButton.style.js.map